import { z } from 'zod';
import { API_DATE_FORMAT } from '~/constants/_constants';
import { zDbId, zLuxonDateTime } from '~/plugins/zod/utils';
import { OrderLinkSchema, PartnerSimpleSchema } from '~/api/links/_types';
import { ContactSimpleSchema } from '../contacts/_types';

export const DeliveryListSimpleSchema = z.object({
    Id: zDbId(),
    DocumentNumber: z.number(),
    ReferenceNumber: z.string().nullable(),
    PostAt: zLuxonDateTime({ format: API_DATE_FORMAT }),
    DueAt: zLuxonDateTime({ format: API_DATE_FORMAT }),
    File: z.string().nullable(),
});

export const DeliveryListInfoSchema = DeliveryListSimpleSchema.and(
    z.object({
        Partner: PartnerSimpleSchema.nullable(),
        Contact: ContactSimpleSchema.nullable(),
        Orders: OrderLinkSchema.array(),
    })
);

export const FetchDeliveryListsResponseSchema = DeliveryListInfoSchema.array();

export type DeliveryListInfo = z.infer<typeof DeliveryListInfoSchema>;
export type FetchDeliveryListsResponse = z.infer<typeof FetchDeliveryListsResponseSchema>;
